<script>
  import IconClose from '@/assets/icon-close.svg';

  export default {
    components: {
      IconClose,
    },

    async mounted () {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: {
            facingMode: 'user',
          },
          audio: false,
        });

        this.$refs.video.srcObject = stream;
      } catch (e) {

      }
    },

    methods: {
      screenshot () {
        const {
          video,
          canvas,
        } = this.$refs;

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        canvas.getContext('2d').drawImage(video, 0, 0);

        canvas.toBlob(blob => this.$emit('image', blob));
      },
    },
  };
</script>

<template>
  <div class="upload-modal">
    <div class="upload-modal__card card scale">
      <div class="card__header">
        <h4 class="card__title">Tirar foto</h4>

        <button
          class="upload-modal__close"
          @click.prevent="$emit('close')"
          >
          <IconClose />
        </button>
      </div>

      <div class="card__body">
        <div class="upload-modal__camera">
          <video class="upload-modal__video" autoplay playsinline ref="video"></video>

          <!-- Camera sensor -->
          <canvas class="upload-modal__canvas" ref="canvas"></canvas>
        </div>

        <div class="upload-modal__footer">
          <button
            class="upload-modal__cancel"
            @click.prevent="$emit('close')"
            >
            Cancelar
          </button>

          <button
            @click.prevent="screenshot"
            class="upload-modal__capture"
            >
            Tirar foto
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .upload-modal {
    top: 0;
    left: 0;
    z-index: 5;
    width: 100vw;
    height: 100vh;
    display: flex;
    padding: 70px 0;
    position: fixed;
    align-items: center;
    justify-content: center;
    background-color: rgba(#14162f, .83);

    &__card {
      width: 770px;
    }

    &__close {
      padding: 0;
      height: 18px;
      margin-left: auto;
    }

    &__cancel {
      color: #FFF;
      font-size: 16px;
      padding: 12px 20px;
      border-radius: 4px;
      align-self: flex-start;
      letter-spacing: 0.86px;
      border: solid 1px #ffffff;

      &:hover {
        background-color: rgba(#FFF, 0.1);
      }
    }

    &__capture {
      color: #FFF;
      margin-left: auto;
      margin-left: 16px;
      padding: 12px 16px;
      border-radius: 4px;
      letter-spacing: 0.32px;
      background-color: #3e388b;

      &:hover {
        background-color: #322c76;
      }
    }

    &__camera {
      width: 100%;
      height: 410px;
      position: relative;
      margin-bottom: 24px;
    }

    &__video,
    &__canvas {
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 10;
      object-fit: cover;
      position: absolute;
    }

    &__footer {
      display: flex;
      justify-content: flex-end;
    }
  }
</style>
